import React from "react";
import { MantineProvider } from "@mantine/core";
import { mantineTheme } from "../Styles/mantineTheme";
import { AppContextProvider } from "../Context/AppContext";
// The logged-out counterpart to Container.tsx. Deliberately renders no MainMenu,
// Alerts or Footer: ReactApp::run() builds those keys (menuConfig, notices,
// warnings, reminders, user) only inside its `if (!$this->isPublic())` branch, so
// on a setPublic(true) page every one of them would render against absent data.
function PublicContainer({ children }) {
    return (React.createElement(MantineProvider, { theme: mantineTheme },
        React.createElement(AppContextProvider, null, children)));
}
export { PublicContainer };
